import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function CheckboxUnchecked(props) {
  const { height, width, backgroundColor } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="22" height="22" rx="1" stroke={backgroundColor} strokeWidth="2" />
    </svg>
  );
}

CheckboxUnchecked.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  backgroundColor: PropTypes.string
};

CheckboxUnchecked.defaultProps = {
  height: 13.5,
  width: 13.5,
  backgroundColor: colors.colorBlue
};

export default CheckboxUnchecked;
